import { errorsStore } from 'stores';

import { IMPORT_RESULTS } from '../constants';

function closeImportErrorsModal() {
  errorsStore.clearError(IMPORT_RESULTS);
}

export { closeImportErrorsModal };
